export const SHOW_DIALOG = 'SHOW_DIALOG'
export const HIDE_DIALOG = 'HIDE_DIALOG'

export const show_dialog = (data, handleok) => {
    return { type: SHOW_DIALOG, title: data.title, message: data.message, handleok}
}

export const hide_dialog = () => {
    return { type: HIDE_DIALOG }
}